const MIT = {
  environment: process.env.REACT_APP_MIT_ENVIRONMENT,
}

export default MIT